import { render } from "./ProjectSectionGoalCollection.vue?vue&type=template&id=6db1e116&scoped=true"
import script from "./ProjectSectionGoalCollection.vue?vue&type=script&lang=js"
export * from "./ProjectSectionGoalCollection.vue?vue&type=script&lang=js"

import "./ProjectSectionGoalCollection.vue?vue&type=style&index=0&id=6db1e116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db1e116"]])

export default __exports__